import './CommentSummaryPopover.css';

import { QuickLink } from './QuickLink';

export const LoadingState = ({ title, buttonText, onClick }) => (
  <div className='base-comment-section'>
    <p className='comment-title'>{title}</p>
    <div data-testid='loading-div' id='loading-div'></div>
    <QuickLink text={buttonText} handleClick={onClick} />
  </div>
);
